import { c as _c } from "react/compiler-runtime";
import type { FileReviewDecisionGlyphChar } from '@/lib/pr-v2/file-review-decisions';
import { PrV2DecisionGlyph } from './pr-v2-decision-glyph';
import { BetterTooltip } from '@/components/ui/tooltip';
import { formatCountedNoun } from '@/lib/auto-fix-loop/outcome-copy';
import { cn } from '@/lib/utils';

/** The orange decision glyph with the decision titles on hover, optionally followed by a count. */
export function PrV2DecisionBadge(t0) {
  const $ = _c(15);
  const {
    label,
    glyph,
    count,
    className
  } = t0;
  let t1;
  if ($[0] !== count || $[1] !== label) {
    t1 = count === undefined ? label : `${formatCountedNoun(count, "review decision")}: ${label}`;
    $[0] = count;
    $[1] = label;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== className) {
    t2 = cn("inline-flex shrink-0 items-center justify-center gap-0.5 text-orange-400", className);
    $[3] = className;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== glyph) {
    t3 = <PrV2DecisionGlyph className="text-xs" glyph={glyph} />;
    $[5] = glyph;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== count || $[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <span role="img" aria-label={t1} className={t2}>{t3}{count}</span>;
    $[7] = count;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== label || $[13] !== t4) {
    t5 = <BetterTooltip content={label} contentClassName="whitespace-pre-line">{t4}</BetterTooltip>;
    $[12] = label;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}